export default "__VITE_ASSET__JzMtccRp__"